module.exports = __webpack_public_path__ + "static/media/arrow-back.d93039ed.svg";